import { useState } from 'react'
import { formSchema } from '../utils/schema/userSchema'
import { useLocation } from 'react-router-dom'

/**
 * This hook adds an extra HTML attribute to the input field 
 *      to identify whether user clicked on the input or not.
 * Based on the attribute added to html we can show our error message
 * 
 * Uses 'OnBlur' event to trigger the change in HTML tag 
 */

const useInputValidation = () => {

//* to get current page info
    const location = useLocation()
    const [fieldTouched, setFieldTouched] = useState<any>({})
    const [error, setError] = useState<any>("")
    
    /** Adding input 'name' attribute to state and setting the value to true*/
    const handleFieldTouch = async (ev: any) => {
        const {name, value} = ev.target;
        setFieldTouched({
            ...fieldTouched,
            [name]: true
        })

        validateField(name, value);
    }

    const validateField = async (name: string, value: string)=>{
            try {
                await formSchema[location.pathname].validateAt(name, {[name]: value});
                setError("");
            } catch (err: any) {
                setError(err.message);
            }
    }
    
    /** Returning the values to bind to the particular HTML input element*/
    const bindValue = (fieldName: string) => ({
        'data-touched': fieldTouched[fieldName],
        onBlur: handleFieldTouch
    })

    /** Adding new value directly to `fieldTouched` object */
    const modifyFieldTouched = (property: string, value: boolean) => setFieldTouched({ ...fieldTouched, [property]: value })
    
    /** Resetting state */
    const reset = () => setFieldTouched({})

    return {bindValue, reset, modifyFieldTouched, error}
}

export default useInputValidation